export default[
    {
        path: '/dataList/data',
        component: resolve => require(['../center.vue'], resolve),
        meta: {
            title: '数据中心',
            keepAlive: false
        }
    }
]